import { ApolloClient, InMemoryCache, HttpLink } from "@apollo/client/core";
import { setContext } from "@apollo/client/link/context";
import { refreshTokenIfNeeded } from "@/utils/auth"; // ✅ Import

// ✅ สร้าง Auth Link เพื่อเพิ่ม JWT Token ในทุก Request
const authLink = setContext((_, { headers }) => {
  // ดึง Token (และรีเฟรชถ้าหมดอายุ)
  const token = refreshTokenIfNeeded();

  return {
    headers: {
      ...headers,
      Authorization: token ? `Bearer ${token}` : "",
    },
  };
});

// ✅ สร้าง HTTP Link
const httpLink = new HttpLink({
  uri: process.env.VUE_APP_API_URL,
});

export const apolloClient = new ApolloClient({
  link: authLink.concat(httpLink), // ✅ เชื่อม authLink กับ httpLink
  cache: new InMemoryCache({
    addTypename: true,
  }),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: "cache-and-network",
      errorPolicy: "all",
    },
    query: {
      fetchPolicy: "network-only",
      errorPolicy: "all",
    },
    mutate: {
      errorPolicy: "all",
    },
  },
});
